<template>
  <div id="app">
    <!-- <MyHeaderVue1 /> -->
    <!-- <MyHeaderVue v-if="!['/about', '/questions', '/protocol'].includes($route.path)" /> -->
    <!-- <MyHeaderVue v-if="!['/privacy'].includes($route.path)" /> -->
    <MyHeaderVue />
    <!-- <MyHeaderVue v-if="['/','/vn/','/vn/about','/vn/question','/vn/protocol'].includes($route.path)" />
    <MyHeaderVue2 v-if="['/th/','/th/about','/th/question','/th/protocol'].includes($route.path)" /> -->
    <router-view></router-view>
    <!-- <MyFooterVue v-if="['/','/vn/','/vn/about','/vn/question','/vn/protocol'].includes($route.path)" />
    <MyFooterVue2 v-if="['/th/','/th/about','/th/question','/th/protocol'].includes($route.path)" /> -->
    <!-- <MyFooterVue v-if="!['/privacy'].includes($route.path)" /> -->
    <MyFooterVue />
  </div>
</template>

<script>
// import MyHeaderVue from './page/chatchaimobile/MyHeader.vue'
// import MyFooterVue from './page/chatchaimobile/MyFooter.vue'

//jaidee官网
// import MyHeaderVue from './page/jaidee/MyHeader.vue'
// import MyFooterVue from './page/jaidee/MyFooter.vue'

//jaideeconnect
// import MyHeaderVue from './page/jaideeconnect/MyHeader.vue'
// import MyFooterVue from './page/jaideeconnect/MyFooter.vue'

//越南kasikvay
// import MyHeaderVue from './page/kasikvay/MyHeader.vue'
// import MyFooterVue from './page/kasikvay/MyFooter.vue'

//墨西哥tamogiefectivo
// import MyHeaderVue from './page/tamogiefectivo/MyHeader.vue'
// import MyFooterVue from './page/tamogiefectivo/MyFooter.vue'

//墨西哥consedeefectivo
// import MyHeaderVue from './page/consedeefectivo/MyHeader.vue'
// import MyFooterVue from './page/consedeefectivo/MyFooter.vue'

//越南nathcopay
// import MyHeaderVue from './page/components/MyHeader5.vue'
// import MyFooterVue from './page/components/MyFooter3.vue'

//越南mrVaymobile
// import MyHeaderVue from './page/mrVaymobile/MyHeader.vue'
// import MyFooterVue from './page/mrVaymobile/MyFooter.vue'

//越南Hcthlog Plus
// import MyHeaderVue from './page/hcthlogplus/MyHeader.vue'
// import MyFooterVue from './page/hcthlogplus/MyFooter.vue'

//墨西哥hipotecariabilletera
// import MyHeaderVue from './page/hipotecariabilletera/MyHeader.vue'
// import MyFooterVue from './page/hipotecariabilletera/MyFooter.vue'

//越南sunmobile
// import MyHeaderVue from './page/sunmobile/MyHeader.vue'
// import MyFooterVue from './page/sunmobile/MyFooter.vue'

//越南cathaydonge
// import MyHeaderVue from './page/cathaydong/MyHeader.vue'
// import MyFooterVue from './page/cathaydong/MyFooter.vue'

//越南newvay
// import MyHeaderVue from './page/newvay/MyHeader.vue'
// import MyFooterVue from './page/newvay/MyFooter.vue'

//墨西哥eldefiardinero
// import MyHeaderVue from './page/eldefiardinero/MyHeader.vue'
// import MyFooterVue from './page/eldefiardinero/MyFooter.vue'

//越南thanhchungplus
// import MyHeaderVue from './page/thanhchungplus/MyHeader.vue'
// import MyFooterVue from './page/thanhchungplus/MyFooter.vue'

//墨西哥dealcorpefectivo
// import MyHeaderVue from './page/dealcorpefectivo/MyHeader.vue'
// import MyFooterVue from './page/dealcorpefectivo/MyFooter.vue'

//墨西哥kampalacash
// import MyHeaderVue from './page/kampalacash/MyHeader.vue'
// import MyFooterVue from './page/kampalacash/MyFooter.vue'

//泰国pheera
// import MyHeaderVue from './page/pheera/MyHeader.vue'
// import MyFooterVue from './page/pheera/MyFooter.vue'

//越南piwbplus
// import MyHeaderVue from './page/piwebplus/MyHeader.vue'
// import MyFooterVue from './page/piwebplus/MyFooter.vue'

//越南piwebplus
// import MyHeaderVue from './page/piwebplus2/MyHeader.vue'
// import MyFooterVue from './page/piwebplus2/MyFooter.vue'

//墨西哥directodoefectivo
// import MyHeaderVue from './page/directodoefectivo/MyHeader.vue'
// import MyFooterVue from './page/directodoefectivo/MyFooter.vue'

//泰国Jaideeonline
// import MyHeaderVue from './page/Jaideeonline/MyHeader.vue'
// import MyFooterVue from './page/Jaideeonline/MyFooter.vue'

//墨西哥braskemefectivo
// import MyHeaderVue from './page/braskemefectivo/MyHeader.vue'
// import MyFooterVue from './page/braskemefectivo/MyFooter.vue'

//墨西哥dealcorpefectivo2
// import MyHeaderVue from './page/dealcorpefectivo2/MyHeader.vue'
// import MyFooterVue from './page/dealcorpefectivo2/MyFooter.vue'

//墨西哥ceibamóvil
// import MyHeaderVue from './page/ceibamóvil/MyHeader.vue'
// import MyFooterVue from './page/ceibamóvil/MyFooter.vue'

//墨西哥estimulocrédito
// import MyHeaderVue from './page/estimulocrédito/MyHeader.vue'
// import MyFooterVue from './page/estimulocrédito/MyFooter.vue'

//墨西哥cincodospréstamos
// import MyHeaderVue from './page/cincodospréstamos/MyHeader.vue'
// import MyFooterVue from './page/cincodospréstamos/MyFooter.vue'

//墨西哥concreecefectivo
// import MyHeaderVue from './page/concreecefectivo/MyHeader.vue'
// import MyFooterVue from './page/concreecefectivo/MyFooter.vue'

//墨西哥daraptipago和wiicredi
// import MyHeaderVue from './page/daraptipago/MyHeader.vue'
// import MyFooterVue from './page/daraptipago/MyFooter.vue'

//泰国microfinmobile
// import MyHeaderVue from './page/microfinmobile/MyHeader.vue'
// import MyFooterVue from './page/microfinmobile/MyFooter.vue'

//墨西哥ammóvil
// import MyHeaderVue from './page/ammóvil/MyHeader.vue'
// import MyFooterVue from './page/ammóvil/MyFooter.vue'

//墨西哥ngernsaen
// import MyHeaderVue from './page/ngernsaen/MyHeader.vue'
// import MyFooterVue from './page/ngernsaen/MyFooter.vue'

//泰国domcap
// import MyHeaderVue from './page/domcap/MyHeader.vue'
// import MyFooterVue from './page/domcap/MyFooter.vue'

//墨西哥cherreypréstamos2
// import MyHeaderVue from './page/cherreypréstamos2/MyHeader.vue'
// import MyFooterVue from './page/cherreypréstamos2/MyFooter.vue'

//墨西哥facicasapresta
// import MyHeaderVue from './page/facicasapresta/MyHeader.vue'
// import MyFooterVue from './page/facicasapresta/MyFooter.vue'

//墨西哥eliteloan
// import MyHeaderVue from './page/eliteloan/MyHeader.vue'
// import MyFooterVue from './page/eliteloan/MyFooter.vue'

//越南drkinhtiềnbạc
// import MyHeaderVue from './page/drkinhtiềnbạc/MyHeader.vue'
// import MyFooterVue from './page/drkinhtiềnbạc/MyFooter.vue'

//越南vajefinance
// import MyHeaderVue from './page/vajefinance/MyHeader.vue'
// import MyFooterVue from './page/vajefinance/MyFooter.vue'

//越南petrolivay
// import MyHeaderVue from './page/petrolivay/MyHeader.vue'
// import MyFooterVue from './page/petrolivay/MyFooter.vue'

//越南lestardong
// import MyHeaderVue from './page/lestardong/MyHeader.vue'
// import MyFooterVue from './page/lestardong/MyFooter.vue'

//越南sunvay
// import MyHeaderVue from './page/sunvay/MyHeader.vue'
// import MyFooterVue from './page/sunvay/MyFooter.vue'

//墨西哥paratidinero
// import MyHeaderVue from './page/paratidinero/MyHeader.vue'
// import MyFooterVue from './page/paratidinero/MyFooter.vue'

//泰国microfin2
// import MyHeaderVue from "./page/microfin2/MyHeader.vue";
// import MyHeaderVue1 from "./page/microfin2/MyHeader1.vue";
// import MyFooterVue from "./page/microfin2/MyFooter.vue";

//泰国domcap2
// import MyHeaderVue from './page/domcap2/MyHeader.vue'
// import MyFooterVue from './page/domcap2/MyFooter.vue'

//泰国ngernsaen2
// import MyHeaderVue from './page/ngernsaen2/MyHeader.vue'
// import MyFooterVue from './page/ngernsaen2/MyFooter.vue'

//越南firefigvay
// import MyHeaderVue from './page/firefigvay/MyHeader.vue'
// import MyFooterVue from './page/firefigvay/MyFooter.vue'

//越南sonthuyvay
// import MyHeaderVue from './page/sonthuyvay/MyHeader.vue'
// import MyFooterVue from './page/sonthuyvay/MyFooter.vue'

//越南truongtaionline
// import MyHeaderVue from './page/truongtaionline/MyHeader.vue'
// import MyFooterVue from './page/truongtaionline/MyFooter.vue'

//越南dhloan
// import MyHeaderVue from './page/dhloan/MyHeader.vue'
// import MyFooterVue from './page/dhloan/MyFooter.vue'

//墨西哥janodinero||fina
// import MyHeaderVue from './page/janodinero/MyHeader.vue'
// import MyFooterVue from './page/janodinero/MyFooter.vue'

//墨西哥kishonefectivo
// import MyHeaderVue from './page/kishonefectivo/MyHeader.vue'
// import MyFooterVue from './page/kishonefectivo/MyFooter.vue'

//墨西哥kishonefectivo2
// import MyHeaderVue from './page/kishonefectivo2/MyHeader.vue'
// import MyFooterVue from './page/kishonefectivo2/MyFooter.vue'

//越南longgsloan
// import MyHeaderVue from './page/longgsloan/MyHeader.vue'
// import MyFooterVue from './page/longgsloan/MyFooter.vue'

//越南hanh
// import MyHeaderVue from './page/hanh/MyHeader.vue'
// import MyFooterVue from './page/hanh/MyFooter.vue'

//泰国subkamolplus
// import MyHeaderVue from './page/subkamolplus/MyHeader.vue'
// import MyFooterVue from './page/subkamolplus/MyFooter.vue'

//泰国ktcnano
// import MyHeaderVue from './page/ktcnano/MyHeader.vue'
// import MyFooterVue from './page/ktcnano/MyFooter.vue'

//泰国nano
// import MyHeaderVue from './page/nano/MyHeader.vue'
// import MyFooterVue from './page/nano/MyFooter.vue'

// 墨西哥lemonade
// import MyHeaderVue from "./page/lemonade/MyHeader.vue";
// import MyFooterVue from "./page/lemonade/MyFooter.vue";

//越南cbmalldong
// import MyHeaderVue from './page/cbmalldong/MyHeader.vue'
// import MyFooterVue from './page/cbmalldong/MyFooter.vue'

//越南onsenmobile
// import MyHeaderVue from './page/onsenmobile/MyHeader.vue'
// import MyFooterVue from './page/onsenmobile/MyFooter.vue'

//墨西哥lordanoupréstamos
// import MyHeaderVue from './page/lordanoupréstamos/MyHeader.vue'
// import MyFooterVue from './page/lordanoupréstamos/MyFooter.vue'

//越南lordanoupréstamos2
// import MyHeaderVue from './page/lordanoupréstamos2/MyHeader.vue'
// import MyFooterVue from './page/lordanoupréstamos2/MyFooter.vue'

//泰国creditmonitor
// import MyHeaderVue from './page/creditmonitor/MyHeader.vue'
// import MyFooterVue from './page/creditmonitor/MyFooter.vue'

//墨西哥mejorandopresta
// import MyHeaderVue from './page/mejorandopresta/MyHeader.vue'
// import MyFooterVue from './page/mejorandopresta/MyFooter.vue'

// //越南koocheemoney
// import MyHeaderVue from './page/koocheemoney/MyHeader.vue'
// import MyFooterVue from './page/koocheemoney/MyFooter.vue'

//墨西哥nitriodinero
// import MyHeaderVue from './page/nitriodinero/MyHeader.vue'
// import MyFooterVue from './page/nitriodinero/MyFooter.vue'

//越南nitriodinero2
// import MyHeaderVue from './page/nitriodinero2/MyHeader.vue'
// import MyFooterVue from './page/nitriodinero2/MyFooter.vue'

//越南zscredit
// import MyHeaderVue from './page/zscredit/MyHeader.vue'
// import MyFooterVue from './page/zscredit/MyFooter.vue'

//墨西哥joylendefectivo
// import MyHeaderVue from './page/joylendefectivo/MyHeader.vue'
// import MyFooterVue from './page/joylendefectivo/MyFooter.vue'

//墨西哥activosmóvil
// import MyHeaderVue from "./page/activosmóvil/MyHeader.vue";
// import MyHeaderVue1 from "./page/activosmóvil/MyHeader1.vue";
// import MyFooterVue from "./page/activosmóvil/MyFooter.vue";

//越南giafinance
// import MyHeaderVue from './page/giafinance/MyHeader.vue'
// import MyFooterVue from './page/giafinance/MyFooter.vue'

//越南debutvay
// import MyHeaderVue from './page/debutvay/MyHeader.vue'
// import MyFooterVue from './page/debutvay/MyFooter.vue'

//墨西哥easycommu
// import MyHeaderVue from './page/easycommu/MyHeader.vue'
// import MyFooterVue from './page/easycommu/MyFooter.vue'

//泰国sinthorn
// import MyHeaderVue from './page/sinthorn/MyHeader.vue'
// import MyFooterVue from './page/sinthorn/MyFooter.vue'

//墨西哥kampalacash2
// import MyHeaderVue from './page/kampalacash2/MyHeader.vue'
// import MyFooterVue from './page/kampalacash2/MyFooter.vue'

//泰国chookiat
// import MyHeaderVue from './page/chookiat/MyHeader.vue'
// import MyFooterVue from './page/chookiat/MyFooter.vue'

//越南hathanh
// import MyHeaderVue from './page/hathanh/MyHeader.vue'
// import MyFooterVue from './page/hathanh/MyFooter.vue'

//越南hoabinhdong
// import MyHeaderVue from './page/hoabinhdong/MyHeader.vue'
// import MyFooterVue from './page/hoabinhdong/MyFooter.vue'

//越南pakvay
// import MyHeaderVue from './page/pakvay/MyHeader.vue'
// import MyFooterVue from './page/pakvay/MyFooter.vue'

//墨西哥paraeldinero
// import MyHeaderVue from './page/paraeldinero/MyHeader.vue'
// import MyFooterVue from './page/paraeldinero/MyFooter.vue'

//越南subkamollending
// import MyHeaderVue from './page/subkamollending/MyHeader.vue'
// import MyFooterVue from './page/subkamollending/MyFooter.vue'

//墨西哥apoyopresta
// import MyHeaderVue from './page/apoyopresta/MyHeader.vue'
// import MyFooterVue from './page/apoyopresta/MyFooter.vue'

//越南namadong
// import MyHeaderVue from './page/namadong/MyHeader.vue'
// import MyFooterVue from './page/namadong/MyFooter.vue'

//越南cdrvaytiền
// import MyHeaderVue from './page/cdrvaytiền/MyHeader.vue'
// import MyFooterVue from './page/cdrvaytiền/MyFooter.vue'

//墨西哥wisementpresta
// import MyHeaderVue from './page/wisementpresta/MyHeader.vue'
// import MyFooterVue from './page/wisementpresta/MyFooter.vue'

//墨西哥urieosmóvil
// import MyHeaderVue from './page/urieosmóvil/MyHeader.vue'
// import MyFooterVue from './page/urieosmóvil/MyFooter.vue'

//越南thtonline
// import MyHeaderVue from './page/thtonline/MyHeader.vue'
// import MyFooterVue from './page/thtonline/MyFooter.vue'

//墨西哥núcleobilletera
// import MyHeaderVue2 from "./page/núcleobilletera/MyHeader2.vue"
// import MyHeaderVue from "./page/núcleobilletera/MyHeader.vue";
// import MyFooterVue from "./page/núcleobilletera/MyFooter.vue";

//墨西哥oportunifyloan
// import MyHeaderVue from './page/oportunifyloan/MyHeader.vue'
// import MyFooterVue from './page/oportunifyloan/MyFooter.vue'

//墨西哥oportunifyloan2
// import MyHeaderVue from './page/oportunifyloan2/MyHeader.vue'
// import MyFooterVue from './page/oportunifyloan2/MyFooter.vue'

//越南namdomobile
// import MyHeaderVue from './page/namdomobile/MyHeader.vue'
// import MyFooterVue from './page/namdomobile/MyFooter.vue'

//越南manhtienvay
// import MyHeaderVue from './page/manhtienvay/MyHeader.vue'
// import MyFooterVue from './page/manhtienvay/MyFooter.vue'

//越南artemisdong
// import MyHeaderVue from './page/artemisdong/MyHeader.vue'
// import MyFooterVue from './page/artemisdong/MyFooter.vue'

//越南huyenvay
// import MyHeaderVue from './page/huyenvay/MyHeader.vue'
// import MyFooterVue from './page/huyenvay/MyFooter.vue'

//墨西哥baranpago
// import MyHeaderVue from './page/baranpago/MyHeader.vue'
// import MyFooterVue from './page/baranpago/MyFooter.vue'

//墨西哥tongshiimportacion
// import MyHeaderVue from './page/tongshiimportacion/MyHeader.vue'
// import MyFooterVue from './page/tongshiimportacion/MyFooter.vue'

//墨西哥tongshiimportacion2
// import MyHeaderVue from './page/tongshiimportacion2/MyHeader.vue'
// import MyFooterVue from './page/tongshiimportacion2/MyFooter.vue'

//墨西哥coparfindinero
// import MyHeaderVue from './page/coparfindinero/MyHeader.vue'
// import MyFooterVue from './page/coparfindinero/MyFooter.vue'

//越南pacwallet
// import MyHeaderVue from './page/pacwallet/MyHeader.vue'
// import MyFooterVue from './page/pacwallet/MyFooter.vue'

//越南quocvay
// import MyHeaderVue from './page/quocvay/MyHeader.vue'
// import MyFooterVue from './page/quocvay/MyFooter.vue'

//越南quangcash
// import MyHeaderVue from './page/quangcash/MyHeader.vue'
// import MyFooterVue from './page/quangcash/MyFooter.vue'

//越南tcamvay
// import MyHeaderVue from './page/tcamvay/MyHeader.vue'
// import MyFooterVue from './page/tcamvay/MyFooter.vue'

//墨西哥confianegocios
// import MyHeaderVue from './page/confianegocios/MyHeader.vue'
// import MyFooterVue from './page/confianegocios/MyFooter.vue'

//墨西哥animoparacrecer
// import MyHeaderVue from './page/animoparacrecer/MyHeader.vue'
// import MyFooterVue from './page/animoparacrecer/MyFooter.vue'

//墨西哥agorarecursos
// import MyHeaderVue from './page/agorarecursos/MyHeader.vue'
// import MyFooterVue from './page/agorarecursos/MyFooter.vue'

//泰国kwamdeebusiness
// import MyHeaderVue from './page/kwamdeebusiness/MyHeader.vue'
// import MyFooterVue from './page/kwamdeebusiness/MyFooter.vue'

//泰国jengtimber
// import MyHeaderVue from './page/jengtimber/MyHeader.vue'
// import MyFooterVue from './page/jengtimber/MyFooter.vue'

//越南anhitinformation
// import MyHeaderVue from './page/anhitinformation/MyHeader.vue'
// import MyFooterVue from './page/anhitinformation/MyFooter.vue'

//越南hungdaianapp
// import MyHeaderVue from './page/hungdaianapp/MyHeader.vue'
// import MyFooterVue from './page/hungdaianapp/MyFooter.vue'

//越南donghaisoftware
// import MyHeaderVue from './page/donghaisoftware/MyHeader.vue'
// import MyFooterVue from './page/donghaisoftware/MyFooter.vue'

//越南tandatphatmoney
// import MyHeaderVue from './page/tandatphatmoney/MyHeader.vue'
// import MyFooterVue from './page/tandatphatmoney/MyFooter.vue'

//越南smartiesconsulting
// import MyHeaderVue from './page/smartiesconsulting/MyHeader.vue'
// import MyFooterVue from './page/smartiesconsulting/MyFooter.vue'

//越南lvsoftcompanylimited
// import MyHeaderVue from './page/lvsoftcompanylimited/MyHeader.vue'
// import MyFooterVue from './page/lvsoftcompanylimited/MyFooter.vue'

//墨西哥donapoyo
// import MyHeaderVue from './page/donapoyo/MyHeader.vue'
// import MyFooterVue from './page/donapoyo/MyFooter.vue'

//泰国vcwealthloan
// import MyHeaderVue from './page/vcwealthloan/MyHeader.vue'
// import MyFooterVue from './page/vcwealthloan/MyFooter.vue'

//墨西哥inmediprest
// import MyHeaderVue from './page/inmediprest/MyHeader.vue'
// import MyFooterVue from './page/inmediprest/MyFooter.vue'

//墨西哥foniclub
// import MyHeaderVue from './page/foniclub/MyHeader.vue'
// import MyFooterVue from './page/foniclub/MyFooter.vue'

//墨西哥alorsi
// import MyHeaderVue from './page/alorsi/MyHeader.vue'
// import MyFooterVue from './page/alorsi/MyFooter.vue'

//越南bonodilecold
// import MyHeaderVue from './page/bonodilecold/MyHeader.vue'
// import MyFooterVue from './page/bonodilecold/MyFooter.vue'

//泰国mitrsinduan
// import MyHeaderVue from './page/mitrsinduan/MyHeader.vue'
// import MyFooterVue from './page/mitrsinduan/MyFooter.vue'

//墨西哥generandorlq
// import MyHeaderVue from './page/generandorlq/MyHeader.vue'
// import MyFooterVue from './page/generandorlq/MyFooter.vue'

//墨西哥zchogorcredito
// import MyHeaderVue from './page/zchogorcredito/MyHeader.vue'
// import MyFooterVue from './page/zchogorcredito/MyFooter.vue'

//墨西哥conficreosofom
// import MyHeaderVue from './page/conficreosofom/MyHeader.vue'
// import MyFooterVue from './page/conficreosofom/MyFooter.vue'

//越南dreamcashddthanh
// import MyHeaderVue from './page/dreamcashddthanh/MyHeader.vue'
// import MyFooterVue from './page/dreamcashddthanh/MyFooter.vue'

//越南chickenfiretown
// import MyHeaderVue from './page/chickenfiretown/MyHeader.vue'
// import MyFooterVue from './page/chickenfiretown/MyFooter.vue'

//越南mangomoneyapp
// import MyHeaderVue from './page/mangomoneyapp/MyHeader.vue'
// import MyFooterVue from './page/mangomoneyapp/MyFooter.vue'

//越南maybaengcompanylimitedapp
// import MyHeaderVue from './page/maybaengcompanylimitedapp/MyHeader.vue'
// import MyFooterVue from './page/maybaengcompanylimitedapp/MyFooter.vue'

//墨西哥kartermax
// import MyHeaderVue from './page/kartermax/MyHeader.vue'
// import MyFooterVue from './page/kartermax/MyFooter.vue'

//越南hauthuycompanylid
// import MyHeaderVue from './page/hauthuycompanylid/MyHeader.vue'
// import MyFooterVue from './page/hauthuycompanylid/MyFooter.vue'

//越南hanvanthuycoldapp
// import MyHeaderVue from './page/hanvanthuycoldapp/MyHeader.vue'
// import MyFooterVue from './page/hanvanthuycoldapp/MyFooter.vue'

//墨西哥fidecreo
// import MyHeaderVue from './page/fidecreo/MyHeader.vue'
// import MyFooterVue from './page/fidecreo/MyFooter.vue'

//墨西哥ttbluescapital
// import MyHeaderVue from './page/ttbluescapital/MyHeader.vue'
// import MyFooterVue from './page/ttbluescapital/MyFooter.vue'

//泰国aira-aiful
// import MyHeaderVue from './page/aira-aiful/MyHeader.vue'
// import MyFooterVue from './page/aira-aiful/MyFooter.vue'

//越南thaidinhphatapp
// import MyHeaderVue from './page/thaidinhphatapp/MyHeader.vue'
// import MyFooterVue from './page/thaidinhphatapp/MyFooter.vue'

//越南speedyloanapp
// import MyHeaderVue from './page/speedyloanapp/MyHeader.vue'
// import MyFooterVue from './page/speedyloanapp/MyFooter.vue'

//越南happycreditapp
// import MyHeaderVue from './page/happycreditapp/MyHeader.vue'
// import MyFooterVue from './page/happycreditapp/MyFooter.vue'

//越南financialcompanionlvay
// import MyHeaderVue from './page/financialcompanionlvay/MyHeader.vue'
// import MyFooterVue from './page/financialcompanionlvay/MyFooter.vue'

//墨西哥agroatoto
// import MyHeaderVue from './page/agroatoto/MyHeader.vue'
// import MyFooterVue from './page/agroatoto/MyFooter.vue'

//越南loanwaveapp
// import MyHeaderVue from './page/loanwaveapp/MyHeader.vue'
// import MyFooterVue from './page/loanwaveapp/MyFooter.vue'

//印尼kspbawanaartha
// import MyHeaderVue from './page/kspbawanaartha/MyHeader.vue'
// import MyFooterVue from './page/kspbawanaartha/MyFooter.vue'

//越南duongvuongtcomld
// import MyHeaderVue from './page/duongvuongtcomld/MyHeader.vue'
// import MyFooterVue from './page/duongvuongtcomld/MyFooter.vue'

//泰国ngoentoryodcompany（0）
// import MyHeaderVue from './page/ngoentoryodcompany/MyHeader.vue'
// import MyFooterVue from './page/ngoentoryodcompany/MyFooter.vue'

//泰国worldleasecompany（0）
// import MyHeaderVue from './page/worldleasecompany/MyHeader.vue'
// import MyFooterVue from './page/worldleasecompany/MyFooter.vue'

//墨西哥ipesofom（0）
// import MyHeaderVue from './page/ipesofom/MyHeader.vue'
// import MyFooterVue from './page/ipesofom/MyFooter.vue'

//越南mekongdevelopmentbank（0）
// import MyHeaderVue from './page/mekongdevelopmentbank/MyHeader.vue'
// import MyFooterVue from './page/mekongdevelopmentbank/MyFooter.vue'

//墨西哥theoutdoorsfinancil(0)
// import MyHeaderVue from './page/theoutdoorsfinancil/MyHeader.vue'
// import MyFooterVue from './page/theoutdoorsfinancil/MyFooter.vue'

//越南prosperityandgrowthcommercialjointbank（0）
// import MyHeaderVue from './page/prosperityandgrowthcommercialjointbank/MyHeader.vue'
// import MyFooterVue from './page/prosperityandgrowthcommercialjointbank/MyFooter.vue'

//越南mongcaitokyoeahhtjsc（0）
// import MyHeaderVue from './page/mongcaitokyoeahhtjsc/MyHeader.vue'
// import MyFooterVue from './page/mongcaitokyoeahhtjsc/MyFooter.vue'

//墨西哥cherreyprestamos
// import MyHeaderVue from './page/cherreyprestamos/MyHeader.vue'
// import MyFooterVue from './page/cherreyprestamos/MyFooter.vue'

//越南quanbinhidbank（0）
// import MyHeaderVue from './page/quanbinhidbank/MyHeader.vue'
// import MyFooterVue from './page/quanbinhidbank/MyFooter.vue'

//泰国seamoneycompany（0）
// import MyHeaderVue from './page/seamoneycompany/MyHeader.vue'
// import MyFooterVue from './page/seamoneycompany/MyFooter.vue'

//越南maritimebankassetmanagement
// import MyHeaderVue from './page/maritimebankassetmanagement/MyHeader.vue'
// import MyFooterVue from './page/maritimebankassetmanagement/MyFooter.vue'

//越南vietcomlimitedcompany(0)
// import MyHeaderVue from './page/vietcomlimitedcompany/MyHeader.vue'
// import MyFooterVue from './page/vietcomlimitedcompany/MyFooter.vue'

//越南bengreenvietnamcompanylimited(0)
//越南-vn
// import MyHeaderVue from './page/bengreenvietnamcompanylimited/vn/MyHeader.vue'
// import MyFooterVue from './page/bengreenvietnamcompanylimited/vn/MyFooter.vue'

// //泰国-th
// import MyHeaderVue2 from './page/bengreenvietnamcompanylimited/th/MyHeader.vue'
// import MyFooterVue2 from './page/bengreenvietnamcompanylimited/th/MyFooter.vue'

//越南emdaycompanylimited
// import MyHeaderVue from './page/emdaycompanylimited/MyHeader.vue'
// import MyFooterVue from './page/emdaycompanylimited/MyFooter.vue'

//越南lvsoftloamapp
// import MyHeaderVue from './page/lvsoftloamapp/MyHeader.vue'
// import MyFooterVue from './page/lvsoftloamapp/MyFooter.vue'

//墨西哥bmtservicios
// import MyHeaderVue from './page/bmtservicios/MyHeader.vue'
// import MyFooterVue from './page/bmtservicios/MyFooter.vue'

//泰国creditcheck-ktcnanowallet
// import MyHeaderVue from './page/creditcheck-ktcnanowallet/MyHeader.vue'
// import MyFooterVue from './page/creditcheck-ktcnanowallet/MyFooter.vue'

//越南dreamvayapploan
// import MyHeaderVue from './page/dreamvayapploan/MyHeader.vue'
// import MyFooterVue from './page/dreamvayapploan/MyFooter.vue'

//墨西哥ceibamovilmx-ficreo
// import MyHeaderVue from './page/ceibamovilmx-ficreo/MyHeader.vue'
// import MyFooterVue from './page/ceibamovilmx-ficreo/MyFooter.vue'

//墨西哥desarrolloorigenesfofor
import MyHeaderVue from './page/desarrolloorigenesfofor/MyHeader.vue'
import MyFooterVue from './page/desarrolloorigenesfofor/MyFooter.vue'

//墨西哥distribuidoradecision
// import MyHeaderVue from './page/distribuidoradecision/MyHeader.vue'
// import MyFooterVue from './page/distribuidoradecision/MyFooter.vue'

//墨西哥lithoimapcolor
// import MyHeaderVue from './page/lithoimapcolor/MyHeader.vue'
// import MyFooterVue from './page/lithoimapcolor/MyFooter.vue'

//越南thanhquanggeneralcompany
// import MyHeaderVue from './page/thanhquanggeneralcompany/MyHeader.vue'
// import MyFooterVue from './page/thanhquanggeneralcompany/MyFooter.vue'

//墨西哥bienestarricotecnologia
// import MyHeaderVue from './page/bienestarricotecnologia/MyHeader.vue'
// import MyFooterVue from './page/bienestarricotecnologia/MyFooter.vue'

//墨西哥lumofinanciera
// import MyHeaderVue from './page/lumofinanciera/MyHeader.vue'
// import MyFooterVue from './page/lumofinanciera/MyFooter.vue'

//墨西哥boomcredit
// import MyHeaderVue from './page/boomcredit/MyHeader.vue'
// import MyFooterVue from './page/boomcredit/MyFooter.vue'

//越南sonduongcompanylimited
// import MyHeaderVue from './page/sonduongcompanylimited/MyHeader.vue'
// import MyFooterVue from './page/sonduongcompanylimited/MyFooter.vue'

//越南maunghiepcompanylimited
// import MyHeaderVue from './page/maunghiepcompanylimited/MyHeader.vue'
// import MyFooterVue from './page/maunghiepcompanylimited/MyFooter.vue'

//越南dolacompanylimited
// import MyHeaderVue from './page/dolacompanylimited/MyHeader.vue'
// import MyFooterVue from './page/dolacompanylimited/MyFooter.vue'

//越南hoangphatcompany
// import MyHeaderVue from './page/hoangphatcompany/MyHeader.vue'
// import MyFooterVue from './page/hoangphatcompany/MyFooter.vue'

//泰国gadzillacompany
// import MyHeaderVue from './page/gadzillacompany/MyHeader.vue'
// import MyFooterVue from './page/gadzillacompany/MyFooter.vue'

//泰国cloudzedcompany
// import MyHeaderVue from './page/cloudzedcompany/MyHeader.vue'
// import MyFooterVue from './page/cloudzedcompany/MyFooter.vue'

//越南nthcompanylimited
// import MyHeaderVue from './page/nthcompanylimited/MyHeader.vue'
// import MyFooterVue from './page/nthcompanylimited/MyFooter.vue'

//泰国khonkaencompany
// import MyHeaderVue from './page/khonkaencompany/MyHeader.vue'
// import MyFooterVue from './page/khonkaencompany/MyFooter.vue'

//越南banghoaapp
// import MyHeaderVue from './page/banghoaapp/MyHeader.vue'
// import MyFooterVue from './page/banghoaapp/MyFooter.vue'

//墨西哥gananciasolidacompany
// import MyHeaderVue from './page/gananciasolidacompany/MyHeader.vue'
// import MyFooterVue from './page/gananciasolidacompany/MyFooter.vue'

//墨西哥masalternativamexico
// import MyHeaderVue from './page/masalternativamexico/MyHeader.vue'
// import MyFooterVue from './page/masalternativamexico/MyFooter.vue'

//越南ankhangcompany
// import MyHeaderVue from './page/ankhangcompany/MyHeader.vue'
// import MyFooterVue from './page/ankhangcompany/MyFooter.vue'

//泰国gomatrixcompany
// import MyHeaderVue from './page/gomatrixcompany/MyHeader.vue'
// import MyFooterVue from './page/gomatrixcompany/MyFooter.vue'

//越南hoasoncompany
// import MyHeaderVue from './page/hoasoncompany/MyHeader.vue'
// import MyFooterVue from './page/hoasoncompany/MyFooter.vue'

//越南migionlinecompany
// import MyHeaderVue from './page/migionlinecompany/MyHeader.vue'
// import MyFooterVue from './page/migionlinecompany/MyFooter.vue'

//墨西哥vatintecnologiacm
// import MyHeaderVue from './page/vatintecnologiacm/MyHeader.vue'
// import MyFooterVue from './page/vatintecnologiacm/MyFooter.vue'

//泰国thaiintercompany
// import MyHeaderVue from './page/thaiintercompany/MyHeader.vue'
// import MyFooterVue from './page/thaiintercompany/MyFooter.vue'

//印尼ksppermatautama
// import MyHeaderVue from './page/ksppermatautama/MyHeader.vue'
// import MyFooterVue from './page/ksppermatautama/MyFooter.vue'

//泰国greefracompany
// import MyHeaderVue from './page/greefracompany/MyHeader.vue'
// import MyFooterVue from './page/greefracompany/MyFooter.vue'

//墨西哥jmfgroup
// import MyHeaderVue from './page/jmfgroup/MyHeader.vue'
// import MyFooterVue from './page/jmfgroup/MyFooter.vue'

//越南wanpaycompany
// import MyHeaderVue from './page/wanpaycompany/MyHeader.vue'
// import MyFooterVue from './page/wanpaycompany/MyFooter.vue'

//越南lavifinancecompany
// import MyHeaderVue from './page/lavifinancecompany/MyHeader.vue'
// import MyFooterVue from './page/lavifinancecompany/MyFooter.vue'

//泰国markale
// import MyHeaderVue from './page/markale/MyHeader.vue'
// import MyFooterVue from './page/markale/MyFooter.vue'

//越南hoangkimcompany
// import MyHeaderVue from './page/hoangkimcompany/MyHeader.vue'
// import MyFooterVue from './page/hoangkimcompany/MyFooter.vue'

//墨西哥olelonsadecv
// import MyHeaderVue from './page/olelonsadecv/MyHeader.vue'
// import MyFooterVue from './page/olelonsadecv/MyFooter.vue'

//越南mekongmobileappvn
// import MyHeaderVue from './page/mekongmobileappvn/MyHeader.vue'
// import MyFooterVue from './page/mekongmobileappvn/MyFooter.vue'

//泰国phasitpakincompany
//  import MyHeaderVue from './page/phasitpakincompany/MyHeader.vue'
//  import MyFooterVue from './page/phasitpakincompany/MyFooter.vue'

//越南daiphatcompany
// import MyHeaderVue from './page/daiphatcompany/MyHeader.vue'
//import MyFooterVue from './page/daiphatcompany/MyFooter.vue'

//墨西哥hipopresamo
// import MyHeaderVue from './page/hipopresamo/MyHeader.vue'
// import MyFooterVue from './page/hipopresamo/MyFooter.vue'

//泰国qmoney-gomatrixcompany
// import MyHeaderVue from './page/qmoney-gomatrixcompany/MyHeader.vue'
// import MyFooterVue from './page/qmoney-gomatrixcompany/MyFooter.vue'

//哥伦比亚avanzasas
// import MyHeaderVue from './page/avanzasas/MyHeader.vue'
// import MyFooterVue from './page/avanzasas/MyFooter.vue'

//墨西哥zonaplatamx
// import MyHeaderVue from './page/zonaplatamx/MyHeader.vue'
// import MyFooterVue from './page/zonaplatamx/MyFooter.vue'

//厄瓜多尔ruartecuador
// import MyHeaderVue from './page/ruartecuador/MyHeader.vue'
// import MyFooterVue from './page/ruartecuador/MyFooter.vue'

//墨西哥asenixcomercializadorasadecv
// import MyHeaderVue from './page/asenixcomercializadorasadecv/MyHeader.vue'
// import MyFooterVue from './page/asenixcomercializadorasadecv/MyFooter.vue'

//越南phubaocompany
// import MyHeaderVue from './page/phubaocompany/MyHeader.vue'
// import MyFooterVue from './page/phubaocompany/MyFooter.vue'

//越南royalstartcompany
// import MyHeaderVue from './page/royalstartcompany/MyHeader.vue'
// import MyFooterVue from './page/royalstartcompany/MyFooter.vue'

//泰国ngernpromchaicompany
// import MyHeaderVue from './page/ngernpromchaicompany/MyHeader.vue'
// import MyFooterVue from './page/ngernpromchaicompany/MyFooter.vue'

//中国sichuanyuanduntechnology
// import MyHeaderVue from './page/sichuanyuanduntechnology/MyHeader.vue'
// import MyFooterVue from './page/sichuanyuanduntechnology/MyFooter.vue'

//越南hatacocompany
// import MyHeaderVue from './page/hatacocompany/MyHeader.vue'
// import MyFooterVue from './page/hatacocompany/MyFooter.vue'

//哥伦比亚colfinactivasas
// import MyHeaderVue from './page/colfinactivasas/MyHeader.vue'
// import MyFooterVue from './page/colfinactivasas/MyFooter.vue'

//泰国thiensuratcompany
// import MyHeaderVue from './page/thiensuratcompany/MyHeader.vue'
// import MyFooterVue from './page/thiensuratcompany/MyFooter.vue'

//泰国moneyzed-cloudzedcompany
// import MyHeaderVue from './page/moneyzed-cloudzedcompany/MyHeader.vue'
// import MyFooterVue from './page/moneyzed-cloudzedcompany/MyFooter.vue'

//泰国quantumvectorcompany
// import MyHeaderVue from './page/quantumvectorcompany/MyHeader.vue'
// import MyFooterVue from './page/quantumvectorcompany/MyFooter.vue'

//泰国allfintechcompany
// import MyHeaderVue from './page/allfintechcompany/MyHeader.vue'
// import MyFooterVue from './page/allfintechcompany/MyFooter.vue'

//中国changshixiangqing
// import MyHeaderVue from './page/changshixiangqing/MyHeader.vue'
// import MyFooterVue from './page/changshixiangqing/MyFooter.vue'

//中国hgzytech
// import MyHeaderVue from './page/hgzytech/MyHeader.vue'
// import MyFooterVue from './page/hgzytech/MyFooter.vue'

//印尼ksppsbungasinarmentari
// import MyHeaderVue from './page/ksppsbungasinarmentari/MyHeader.vue'
// import MyFooterVue from './page/ksppsbungasinarmentari/MyFooter.vue'

//泰国bigmoneypluscompany
// import MyHeaderVue from './page/bigmoneypluscompany/MyHeader.vue'
// import MyFooterVue from './page/bigmoneypluscompany/MyFooter.vue'

//越南hvaymuon-phubaocompany
// import MyHeaderVue from './page/hvaymuon-phubaocompany/MyHeader.vue'
// import MyFooterVue from './page/hvaymuon-phubaocompany/MyFooter.vue'

//厄瓜多尔easycommuservicessas
// import MyHeaderVue from './page/easycommuservicessas/MyHeader.vue'
// import MyFooterVue from './page/easycommuservicessas/MyFooter.vue'

//越南ddlinkcompany
// import MyHeaderVue from './page/ddlinkcompany/MyHeader.vue'
// import MyFooterVue from './page/ddlinkcompany/MyFooter.vue'

//泰国budgetmanager.khonkaencompany
// import MyHeaderVue from './page/budgetmanager-khonkaencompany/MyHeader.vue'
// import MyFooterVue from './page/budgetmanager-khonkaencompany/MyFooter.vue'


export default {
  name: "App",
  components: {
    // MyHeaderVue1,
    MyHeaderVue,
    MyFooterVue,
    // MyHeaderVue2,
    // MyFooterVue2,
  },
};
</script>

<style>
#app {
  color: #2c3e50;
}
</style>


<!-- <style>
/* 墨西哥distribuidoradecision */
#app {
  color: #2c3e50;
  zoom: 0.5;
}
</style> -->
